module.exports = __webpack_public_path__ + "img/research-group-4.079fd36e.jpg";